<template>
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="login-card login-dark">
                    <div>
                        <div><router-link class="logo" to="/"><img class="img-fluid for-light" style="width: 28vh;"
                                    src="@/assets/images/logo/office-design-logo-white.png" alt="looginpage"><img class="img-fluid for-dark"
                                    src="@/assets/images/logo/office-design-logo-white.png" alt="looginpage"></router-link></div>
                        <div class="login-main">
                            <form class="theme-form" @submit.prevent="">
                                <h4>Sign in to account</h4>
                                <p>Enter your email & password to login</p>
                                <div class="form-group">
                                    <label class="col-form-label">Email Address</label>
                                    <input v-model="email" class="form-control" type="email">
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label">Password</label>
                                    <div class="form-input position-relative">
                                        <input v-model="password" :type="type" class="form-control" name="login[password]">
                                        <div class="show-hide"><span class="show" @click="showPassword"> </span></div>
                                    </div>
                                </div>
                                <div class="form-group mb-0">
                                    <div class="checkbox p-0">
                                        <input id="checkbox1" type="checkbox">
                                        <label class="text-muted" for="checkbox1">Remember password</label>
                                    </div>
                                    <div class="text-end mt-3">
                                        <button class="btn btn-primary btn-block w-100" type="submit" @click="doLogin">Sign
                                            in</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script lang="ts" setup>
import { ref } from "vue"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { useRouter } from 'vue-router'
import { directus } from "@/services/directus"
import { readUsers } from "@directus/sdk"

let router = useRouter()
let type = ref<string>('password')
let email = ref<string>("")
let password = ref<string>("")

function showPassword() {
    if (type.value === 'password') {
        type.value = 'text';
    } else {
        type.value = 'password';
    }
}

async function doLogin() {
    if (email.value && password.value) {
        try {
            await directus.login(email.value, password.value);
            const response = await directus.request(
                readUsers({
                    filter: {
                        email: { _eq: email.value },
                    },
                    fields: ["*"],
                })
            );
            const login = response[0]

            localStorage.setItem('user_first_name', login.first_name)
            localStorage.setItem('user_last_name', login.last_name)
            localStorage.setItem('user_full_name', `${login.first_name} ${login.last_name}`)
            localStorage.setItem('user', email.value)
            localStorage.setItem("SidebarType", 'compact-wrapper')
            router.replace('/receipt/list_stock');
            toast.success('Login Successfully ', { position: 'top-right', autoClose: 2000 });
        } catch(err: any) {
            toast.error('Login failed: ' + (err?.message || 'Unknown error'), { position: 'top-right', autoClose: 2000 });
        }
    }
    else {
        toast.error('Opps... Invalid email and password ', { position: 'top-right', autoClose: 2000 });
    }
}
</script>